import React from "react";

export function OperatorMachinesHelpContent() {
  return (
    <>
      <p>
        Lista as máquinas que o operador selecionado assumiu no período, com data,
        horímetro e foto do painel quando disponível.
      </p>
      <p>
        Use o atalho <strong>Ver em Operações</strong> para abrir o monitoramento da
        máquina em outra tela da plataforma.
      </p>
    </>
  );
}
